import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabaseClient';

export default function Logout() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogout = async () => {
    setError('');
    setLoading(true);

    const { error } = await supabase.auth.signOut();

    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="min-h-screen bg-pink-50 flex flex-col items-center justify-center p-8">
      <h2 className="text-3xl font-bold text-pink-600 mb-6">Logout</h2>
      <div className="bg-white p-6 rounded shadow-md w-full max-w-sm">
        {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
        <p className="text-gray-600 mb-4">Are you sure you want to logout?</p>
        <button
          onClick={handleLogout}
          className="w-full bg-pink-500 hover:bg-pink-600 text-white py-2 px-4 rounded disabled:opacity-50"
          disabled={loading}
        >
          {loading ? 'Logging out...' : 'Logout'}
        </button>
      </div>
    </div>
  );
}